export { default } from './IconTitle';
export * from './IconTitle';
